export default "__VITE_ASSET__BBP5aw0m__"